import { aboutStats, aboutPoints } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20" aria-labelledby="about-title">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="About Us"
          title="让每一口瓜，都吃得明白"
          desc="吃瓜视界是一站式娱乐资讯聚合门户。我们相信热点的背后是真实的生活，因此坚持用真实、克制、有温度的方式，帮大家把瓜吃清、吃透。"
        />

        <div className="mb-10 grid grid-cols-2 gap-3 sm:grid-cols-4 md:mb-12">
          {aboutStats.map((s, i) => (
            <div
              key={s.label}
              className={`rounded-2xl border px-4 py-5 text-center md:py-6 ${
                i === 1 ? 'border-accent-200 bg-accent-100/70' : 'border-background-200 bg-background-100/60'
              }`}
            >
              <p className={`font-heading text-2xl font-black md:text-3xl ${i === 1 ? 'text-accent-700' : 'text-foreground-950'}`}>{s.num}</p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="flex flex-col justify-center">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">我们是谁，为什么做吃瓜视界</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              在信息又快又碎的时代，刷瓜常常变成东一榔头、西一棒槌，最后什么也没看明白。吃瓜视界的初心，就是把散落在各处的
              明星八卦、社会热点、影视综艺与文旅消费，整理成清晰、连续、可信的内容，让你不再东找西找，打开就能刷个够。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              作为内容型资讯平台，我们不追流量制造的焦虑，也不靠猎奇博眼球。更想扮演一个“整理者”和“翻译者”，
              把真实的一手信息讲清楚，把值得讨论的议题讲深透，和每一位吃瓜的你一起，理性吃瓜、快乐追更。
            </p>
            <div className="mt-6 rounded-xl border border-primary-200 bg-primary-50 p-4 md:p-5">
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-700">
                <i className="ri-flag-line" style={{ width: 15, height: 15 }} />
                内容原则
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-800">
                真实为先、极速速递、转载注明出处、争议内容明确标注待核实；尊重当事人与版权，拒绝恶意炒作与低俗猎奇。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {aboutPoints.map((p) => (
              <div key={p.title} className="group rounded-2xl border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-accent-200 hover:bg-accent-50/70">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={p.icon} style={{ width: 22, height: 22, fontSize: 22 }} />
                </span>
                <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}